var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      staticClass: "capped-value__wrapper",
      class: { "flex-column": _vm.isCapped }
    },
    [
      _c(
        "span",
        {
          staticClass: "capped-value__span",
          class: { "capped-max": _vm.isCapped }
        },
        [
          _vm.isAmountType ? _c("span", [_vm._v("$")]) : _vm._e(),
          _vm._v("\n    " + _vm._s(_vm.computedValue) + "\n  ")
        ]
      ),
      _vm._v(" "),
      _vm.validCap
        ? _c("span", { staticClass: "capped-value capped-value__span" }, [
            _vm._v("\n    / "),
            _vm.isAmountType ? _c("span", [_vm._v("$")]) : _vm._e(),
            _vm._v("\n    " + _vm._s(_vm.cap) + "\n  ")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }